import router from "../router";
import { useUserStore } from "../store/modules/user";
import { FEATURE, permission, permissionsByRole } from "../utils/constants/permission";
import { isFeatureActive } from "../composables/useFeatureFlag";
import { isRole, Roles } from "../utils/constants/user";

export const addRouteGuard = () => {
  const store = useUserStore();
  router.beforeResolve(async (to, from, next) => {
    try {
      if (store.authStatus == "error") {
        next();
        return;
      }
      if (store.authStatus == "" && store.getToken.length > 0) {
        await store.userRequest();
        next();
        return;
      } else if (store.authStatus == "") {
        store.userIdle();
        if (to.path == "/changePassword") {
          next();
        } else {
          next("/");
        }
        return;
      }
      if (isExpiredToken(store.getToken)) {
      }
      const role = store.getProfile.role;

      if (to.meta.rolesAllowed) {
        if (to.meta.rolesAllowed.length > 0) {
          if (!to.meta.rolesAllowed.includes(role)) {
            router.push({ name: "navigation.accessdenied", force: true });
          }
        }
      }

      next();
    } catch (e) {
      next("/");
    }
  });
};

export const isAuthorized = (permission: permission) => {
  const store = useUserStore();
  let role = "PUBLIC" as Roles;
  const foundRole = store.getProfile.role as Roles | string | undefined;
  if (foundRole != null) {
    if (isRole(foundRole)) {
      role = foundRole;
    }
  }

  const allowedPermissions = permissionsByRole[permission];
  if (allowedPermissions.includes(role)) {
    return true;
  }
  return false;
};

// All features are enabled for all tenants; kept as a stable call site for callers.
export const featureEnabled = (_feature: FEATURE) => {
  return true;
};

export const parseJWTToken = (token: string) => {
  try {
    return JSON.parse(atob(token.split(".")[1]));
  } catch (e) {
    return null;
  }
};

export const isExpiredToken = (token: string) => {
  let isExpired = false;
  if (token.length > 0) {
    const decodedJwt = parseJWTToken(token);
    if (decodedJwt.exp * 1000 < Date.now()) {
      isExpired = false;
    }
    return isExpired;
  }
};
